import { useSelector } from "@jti/store";
import useCurrentPrice from "./useCurrentPrice";
const useTotal = (isFreeTrial, isStandardCheckoutFlow, selectedOrderDetails) => {
    const { id: cartId, currency } = useSelector((state) => state.cart);
    const { id: freeTrialId, currency: freeTrialCurrency } = useSelector((state) => state.freeTrialCart);
    const prices = useCurrentPrice(isFreeTrial, isStandardCheckoutFlow, selectedOrderDetails);
    return {
        cartId: isFreeTrial ? freeTrialId : cartId,
        shopCurrency: isFreeTrial ? freeTrialCurrency : currency,
        totalPrice: prices ? (isFreeTrial ? prices.total : prices.grandTotal?.value) : null,
    };
};
export default useTotal;
//# sourceMappingURL=useTotal.js.map